import {createTheme} from '@mui/material/styles';

const lightTheme = createTheme({
  typography: {
    fontFamily: `"Helvetica Neue 9", "Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 13,
  },

  breakpoints: {
    values: {xs: 375, sm: 640, md: 1024, lg: 1440, xl: 1920},
  },
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      main: '#4DB6AC',
    },
    success: {
      dark: '#2F9087',
      main: '#4CAF50',
    },
    warning: {
      main: '#FF9800',
    },
    error: {
      light: '#E57373',
      main: '#F44336',
    },
    info: {
      dark: '#1976D2',
      main: '#2196F3',
    },
    secondary: {
      contrastText: '#A6B3BA',
      dark: '#636B73',
      light: '#E5ECF0',
      main: '#2F3337',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {root: {borderRadius: '4px', boxShadow: 'none', '&:hover': {boxShadow: 'none'}}},
    },
    MuiAutocomplete: {
      defaultProps: {
        autoSelect: true,
        clearOnBlur: true,
      },
    },
    MuiTextField: {
      defaultProps: {size: 'small'},
    },
    MuiOutlinedInput: {
      styleOverrides: {root: {borderRadius: '4px'}},
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  },
});

export default lightTheme;
